import React from "react";
import styles from "./RightSidebarHeader.module.scss";

import { ZiplineTabs } from "../ZiplineTabs";
import { Icon } from "../../atoms/Icon";
import classnames from "classnames";

function RightSidebarHeader({
  title,
  onDismiss,
  isDismissDisabled,
  className,
  onTabSelect = () => {},
  activeTab = "",
  tabTitles = [],
  loading
}) {
  return (
    <div className={classnames(styles.rightSidebarHeader, className)}>
      <div className={styles.titleContainer}>
        <h2>{title}</h2>
        <Icon
          name="cross"
          size={20}
          className={classnames(
            isDismissDisabled && styles.disabled,
            styles.exitRightSidebarIcon
          )}
          onClick={!isDismissDisabled ? onDismiss : () => {}}
        />
      </div>

      <ZiplineTabs
        selectedTabId={activeTab}
        onTabSelect={onTabSelect}
        tabTitles={tabTitles}
        loading={loading}
      />
    </div>
  );
}

export default RightSidebarHeader;
